module.exports = __webpack_public_path__ + "static/media/autokar2 (4).dd941ccf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar2 (4).jpg
// module id = 851
// module chunks = 0